// Jours fériés chômés · convention collective Commerce et divers de Nouvelle-Calédonie
const easter = (y) => {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return Date.UTC(y, month - 1, day);
};

const DAY = 86400000;
const key = (t) => new Date(t).toISOString().slice(0, 10);

export const holidays = (y) => {
  const e = easter(y);
  return {
    [key(Date.UTC(y, 0, 1))]: "Jour de l'An",
    [key(e + DAY)]: "Lundi de Pâques",
    [key(Date.UTC(y, 4, 1))]: "Fête du Travail",
    [key(e + 50 * DAY)]: "Lundi de Pentecôte",
    [key(Date.UTC(y, 6, 14))]: "Fête nationale",
    [key(Date.UTC(y, 8, 24))]: "Fête de la Citoyenneté",
    [key(Date.UTC(y, 11, 25))]: "Noël",
  };
};

const WEEKDAYS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const isOpenDay = (t) => {
  const d = new Date(t), wd = d.getUTCDay();
  return wd !== 0 && wd !== 6 && !holidays(d.getUTCFullYear())[key(t)];
};

// Nouméa date as a UTC-midnight timestamp + current hour
const noumeaNow = () => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: "Pacific/Noumea", year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", hour12: false }).formatToParts(new Date()).map((x) => [x.type, x.value]));
  return { today: Date.UTC(+p.year, +p.month - 1, +p.day), hour: Number(p.hour) % 24 };
};

export const supportStatus = () => {
  const { today, hour } = noumeaNow();
  const holiday = holidays(new Date(today).getUTCFullYear())[key(today)];
  if (isOpenDay(today) && hour >= 7 && hour < 17) return [true, "Support ouvert · prise en charge immédiate"];
  if (isOpenDay(today) && hour < 7) return [false, "Support fermé · ouverture à 7h"];
  let next = today + DAY;
  while (!isOpenDay(next)) next += DAY;
  const n = (next - today) / DAY;
  const when = n === 1 ? "demain" : n < 7 ? WEEKDAYS[new Date(next).getUTCDay()] : `le ${new Date(next).getUTCDate()}/${new Date(next).getUTCMonth() + 1}`;
  return [false, `Support fermé${holiday ? ` (${holiday})` : ""} · réouverture ${when} à 7h`];
};
